export default __webpack_public_path__ + "alberta-medical-technology.abb5cbf84ef2d8c53d91.svg";